import React from "react";

/* eslint-disable max-len */
export default function WhitePlayIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={65} height={90} viewBox="0 0 65 90">
            <path
                d="M61.437 42.533a3 3 0 010 4.933L4.707 86.74A3 3 0 010 84.274V5.726a3 3 0 014.708-2.467z"
                fill="#fff"
                opacity={0.499}
            />
        </svg>
    );
}
